var _defineProperty = require("/private/tmp/ncsacw-website/frontend/node_modules/@babel/runtime/helpers/defineProperty.js");
var once = require("receptor/once");
var behavior = require("../../uswds-core/src/js/utils/behavior");
var _require = require("../../uswds-core/src/js/events"),
  CLICK = _require.CLICK;
var _require2 = require("../../uswds-core/src/js/config"),
  PREFIX = _require2.prefix;
var LINK = ".".concat(PREFIX, "-skipnav[href^=\"#\"], .").concat(PREFIX, "-footer__return-to-top [href^=\"#\"]");
var MAINCONTENT = "main-content";
function setTabindex() {
  // NB: we know because of the selector we're delegating to below that the
  // href already begins with '#'
  var id = encodeURI(this.getAttribute("href"));
  var target = document.getElementById(id === "#" ? MAINCONTENT : id.slice(1));
  if (target) {
    target.style.outline = "0";
    target.setAttribute("tabindex", 0);
    target.focus();
    target.addEventListener("blur", once(function () {
      target.setAttribute("tabindex", -1);
    }));
  } else {
    // throw an error?
  }
}
module.exports = behavior(_defineProperty({}, CLICK, _defineProperty({}, LINK, setTabindex)));